import { render, staticRenderFns } from "./DepositPage.vue?vue&type=template&id=5b06c292"
import script from "./DepositPage.vue?vue&type=script&lang=js"
export * from "./DepositPage.vue?vue&type=script&lang=js"
import style0 from "./DepositPage.vue?vue&type=style&index=0&id=5b06c292&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme2DesktopProfilesDepositsBankTransfer: require('/app/components/Theme2/Desktop/Profiles/Deposits/BankTransfer.vue').default,Theme2DesktopProfilesDepositsThirdPartyPayment: require('/app/components/Theme2/Desktop/Profiles/Deposits/ThirdPartyPayment.vue').default,Theme2DesktopProfilesDepositsCryptoPayment: require('/app/components/Theme2/Desktop/Profiles/Deposits/CryptoPayment.vue').default,Theme2DesktopProfilesDepositsQRTransfer: require('/app/components/Theme2/Desktop/Profiles/Deposits/QRTransfer.vue').default,Theme2DesktopForceToAddBankAndWallet: require('/app/components/Theme2/Desktop/ForceToAddBankAndWallet.vue').default})
